import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import Link from "next/link";
import GiftPicture from '../../assets/img/gift-card.jpg';
import { Button, Checkbox } from '../../components';

import {
  PanelMobile,
  MobileButton,
  MobileTotal,
  PanelContainer,
  PanelImageContainer,
  PanelPaymentInfo,
  PanelPaymentItem,
  PanelPaymentDelimiter,
  PanelPaymentHeading,
  PanelPaymentButtonContainer,
  PanelPaymentCheckboxContainer,
  CheckboxDescription,
} from './styles';

const PaymentInfoContainer = ({ product, price, total, formInstance }) => {
  const [isDisabled, handleDisabledState] = useState(true);

  return (
    <PanelPaymentInfo>
      <PanelMobile>
        <MobileTotal>
          <h3>Total</h3>
          <p>${total}</p>
        </MobileTotal>
        <MobileButton>
          <Button
            htmlType="button"
            theme="primary"
            onClick={formInstance && formInstance.submitForm}
            disabled={isDisabled}
          >
            Purchase
          </Button>
        </MobileButton>
      </PanelMobile>
      <PanelPaymentHeading>Confirm and pay</PanelPaymentHeading>
      <PanelPaymentItem>
        <span className="semibold">{product}</span>
        <span className="semibold medium blue">${price}</span>
      </PanelPaymentItem>
      <PanelPaymentDelimiter />
      <PanelPaymentItem>
        <span className="bold">Total</span>
        <span className="bold large">${total}</span>
      </PanelPaymentItem>
      <PanelPaymentButtonContainer>
        <Button
          htmlType="button"
          theme="primary"
          onClick={formInstance && formInstance.submitForm}
          disabled={isDisabled}
        >
          Purchase
        </Button>
      </PanelPaymentButtonContainer>
      <PanelPaymentCheckboxContainer>
        <Checkbox
          name="terms"
          value="terms"
          id="terms"
          blue
          checked={!isDisabled}
          onChange={() => handleDisabledState(!isDisabled)}
          label={(
            <CheckboxDescription>
              By completing my order I agree with{' '}
              <Link href="/terms">
                <a target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
              </Link>
            </CheckboxDescription>
          )}
        />
      </PanelPaymentCheckboxContainer>
    </PanelPaymentInfo>
  );
};

const PaymentImage = () => (
  <PanelImageContainer>
    <img src={GiftPicture} alt="eGift Pass" />
  </PanelImageContainer>
);

PaymentInfoContainer.propTypes = {
  product: PropTypes.string,
  price: PropTypes.number,
  total: PropTypes.number,
  formInstance: PropTypes.instanceOf(Object),
};

class GiftPanel extends Component {
  static PanelContainer = PanelContainer;

  static PanelImageContainer = PaymentImage;

  static PaymentInfo = PaymentInfoContainer;

  render() {
    return null;
  }
}

export default GiftPanel;
